import { ASYNC_ACTION_START, ASYNC_ACTION_END, ASYNC_ACTION_DONE, NO_RESPONSE_ERROR } from "../mutations.type";
import { FINALIZE_ACTION } from "../actions.type";

export const STATUS = {
    NONE: "",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    EMAIL_EXISTS: "EMAIL_EXISTS",
    OLD_PASSWORD: "OLD_PASSWORD"
};

export const asyncState = function (...actions) {
    return {status: actions.reduce(function(acc, cur, i) {
            acc[cur] = STATUS.NONE;
            return acc;
        }, {})};
};

export const asyncGetters = function () {
    return {
        status: (state) => (statusType => {
            if(state.status.hasOwnProperty(statusType)) {
                return state.status[statusType];
            }
        }),
        isPending: (state, getters) => (statusType => {
            return getters.status(statusType) === STATUS.PENDING;
        }),
        isFinished: (state, getters) => (statusType => {
            let status = getters.status(statusType);
            return status === STATUS.SUCCESS || status === STATUS.FAILURE;
        }),
        emailExists: (state, getters) => (statusType => {
            return getters.status(statusType) === STATUS.EMAIL_EXISTS;
        }),
    }
};

export const mapAsyncGetters = function (action) {
    return {
        status: function () {
            return this.$store.getters['status'](action);
        },
        isPending: function () {
            return this.$store.getters['isPending'](action);
        },
        isFinished: function () {
            return this.$store.getters['isFinished'](action);
        },
        emailExists: function () {
            return this.$store.getters['emailExists'](action);
        }
    };
};

export const asyncActions = function () {
    return {
        // Finalize Async Action
        [FINALIZE_ACTION]({commit}, action) {
            commit(ASYNC_ACTION_DONE, action);
        },
    }
};

export const asyncMutations = function () {
    return {
        [ASYNC_ACTION_START](state, action) {
            state.status[action] = STATUS.PENDING;
        },
        [ASYNC_ACTION_END](state, mutationPayload) {
            if (mutationPayload.response.status === mutationPayload.asyncOperation.successCode) {
                state.status[mutationPayload.asyncOperation.action] = STATUS.SUCCESS;
                if(mutationPayload.asyncOperation.hasOwnProperty('mutation')) {
                    mutationPayload.asyncOperation.mutation(state, mutationPayload.response);
                }
            } else {
                state.status[mutationPayload.asyncOperation.action] = STATUS.FAILURE;
            }
        },
        [ASYNC_ACTION_DONE](state, action){
            state.status[action] = STATUS.NONE;
        },
        [NO_RESPONSE_ERROR](state, mutationPayload){
            if (mutationPayload.response && mutationPayload.response.status && mutationPayload.asyncOperation.errors) {
                for (let code in errors) {
                    if (errors.hasOwnProperty(code) && (parseInt(code) === mutationPayload.response.status)) {
                        state.status[mutationPayload.asyncOperation.action] = errors[code];
                    }
                }
            } else {
                state.status[mutationPayload.asyncOperation.action] = STATUS.FAILURE;
            }
        }
    }
};

export const toMutationPayload = function (asyncOperation, response) {
    return {
        asyncOperation: asyncOperation,
        response: response
    }
};

export default {
    STATUS,
    asyncState,
    asyncGetters,
    asyncActions,
    asyncMutations,
    mapAsyncGetters
};